import { Market } from '../../types/shared/Market';
import { Field } from '../../types/shared/Vendor';

import IndexedList from './IndexedList';
import { APP_FIELDS } from './constants/Constants';
import toStringArray from './toStringArray';

export function getAttendingDates(market: Market, fields: IndexedList<Field>) {
  let { id, dates } = market;
  let marketsField = fields?.getByID(APP_FIELDS.ID_FIELD_MARKETS);
  let selectedDates = new Set(toStringArray(Object(marketsField?.value)[id]));
  return dates.filter((date) => selectedDates.has(date));
}
